import React, { useState } from "react";
import "./ModalValueOffer.css";

function DropDownMenu({ listValues, isModalVisible, onDeleteClick, selectedTerms, setSelectedTerms}) {
  //const [selectedValues, setSelectedValues] = useState([]);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleCheckboxChange = (id) => {
    setSelectedTerms((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((value) => value !== id)
        : [...prevSelected, id]
    );
  };

  const handleCollapseToggle = () => {
    setIsCollapsed((prev) => !prev);
  };

  return (
    <>
      {isModalVisible && (
        <div className="modal-container">
          {!isCollapsed && (
            <>
              <label>TERMINOS Y CONDICIONES*</label>
              <div className="checkbox-list">
                {listValues.map((item) => (
                  <label key={item.id}>
                    <input
                      type="checkbox"
                      checked={selectedTerms.includes(item.id)}
                      onChange={() => handleCheckboxChange(item.id)}
                    />
                    {item.description}
                  </label>
                ))}
              </div>
          </>
          )}
          <button className="checkbox-list-button mb-3" 
            onClick={handleCollapseToggle}
            icon="arrow">
            {isCollapsed ? "+ Mostrar términos y condiciones" : "- Ocultar términos y condiciones"}
          </button>
          <div className="button-container">
            <button className="buttonDelete"
              onClick={(e) => onDeleteClick(e.target.isModalVisible)}>
              Eliminar
            </button>
          </div>
          <div className="mt-2"/>
          <hr/>
        </div>
      )}
    </>
  );
}

function DropDownMenuTerms({isModalVisible, onDeleteClick, values, selectedTerms, setSelectedTerms}) {

  return (
    <DropDownMenu
      listValues={values}
      isModalVisible={isModalVisible}
      onDeleteClick={onDeleteClick}
      selectedTerms={selectedTerms}
      setSelectedTerms={setSelectedTerms}
  />);
}

export { DropDownMenuTerms };